'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlgoName = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _extends2;

exports.getExecutionType = getExecutionType;

var _IdentifierUtils = require('@omniex/onx-common-js/lib/utils/IdentifierUtils');

var _LangUtils = require('@omniex/onx-common-js/lib/utils/LangUtils');

var _OrderAlgorithmStrategy = require('../enums/OrderAlgorithmStrategy');

var _OrderAlgorithmStrategy2 = _interopRequireDefault(_OrderAlgorithmStrategy);

var _OrderExecutionType = require('../enums/OrderExecutionType');

var _OrderExecutionType2 = _interopRequireDefault(_OrderExecutionType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALGO_NAMES = (0, _extends4.default)({}, _OrderAlgorithmStrategy2.default, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _OrderAlgorithmStrategy2.default.ICE, 'ICEBERG'), (0, _defineProperty3.default)(_extends2, _OrderAlgorithmStrategy2.default.PVWAP, 'PASSIVE VWAP'), (0, _defineProperty3.default)(_extends2, _OrderAlgorithmStrategy2.default.SVWAP, 'VWAP'), _extends2));

var getAlgoName = exports.getAlgoName = function getAlgoName(algo) {
  return ALGO_NAMES[algo] || '';
};

function getExecutionType(order) {
  if ((0, _values2.default)(_OrderAlgorithmStrategy2.default).includes(order.algorithmStrategy)) {
    return _OrderExecutionType2.default.ALGO;
  }

  if ((0, _IdentifierUtils.isValid)(order.fixQuoteID)) {
    return _OrderExecutionType2.default.RFQ;
  }

  if (!(0, _LangUtils.isNil)(order.espTileGroup)) {
    return _OrderExecutionType2.default.ESP;
  }

  return _OrderExecutionType2.default.DMA;
}